import { CommonModule } from '@angular/common';
import { Component, Input, Type, ViewEncapsulation } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import {
  UiStepperActionContext,
  UiStepperState,
  UiStepperStep,
} from './stepper.types';
import { StepperIconComponent } from './stepper-icon.component';

@Component({
  selector: 'app-stepper-main-step',
  standalone: true,
  imports: [CommonModule, StepperIconComponent, NgbTooltip],
  templateUrl: './stepper-main-step.component.html',
  styleUrl: './stepper-main-step.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class StepperMainStepComponent {
  @Input({ required: true }) step!: UiStepperStep;

  @Input({ required: true }) index = 0;

  @Input() connectorActive = false;

  @Input() showConnector = false;

  get state(): UiStepperState {
    return this.step.state ?? 'pending';
  }

  get numericIndex(): number {
    return this.index + 1;
  }

  get isOptional(): boolean {
    return this.step.required === false;
  }

  get showAction(): boolean {
    return this.hasCustomAction || this.hasButtonAction;
  }

  get hasCustomAction(): boolean {
    return Boolean(this.step.actionComponent?.component);
  }

  get hasButtonAction(): boolean {
    return !this.hasCustomAction && Boolean(this.step.action);
  }

  get customActionComponent(): Type<unknown> | null {
    return this.step.actionComponent?.component ?? null;
  }

  get customActionInputs(): Record<string, unknown> {
    return this.step.actionComponent?.inputs ?? {};
  }

  get actionAriaLabel(): string {
    return (
      this.step.action?.ariaLabel ??
      this.step.action?.label ??
      `${this.step.label} action`
    );
  }

  get actionTooltip(): string | null {
    return this.step.action?.tooltip ?? null;
  }

  get actionColor(): string {
    if (this.step.action?.disabled) {
      return 'var(--light-gray-500)';
    }
    return this.step.action?.color ?? 'var(--brand-600)';
  }

  handleActionClick(): void {
    if (!this.step.action?.onClick || this.step.action.disabled) {
      return;
    }

    const context: UiStepperActionContext = {
      step: this.step,
      stepIndex: this.index,
    };

    this.step.action.onClick(context);
  }
}
